// npm packages
import { Container, Row, Col, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// project imports
import { ContactForm } from "./ContactForm";

import "animate.css";

import "./ContactMe.css";

export const ContactMe = () => {
  const { t } = useTranslation();

  return (
    <section className="contact" id="contact">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col sm={9}>
            <div className={"animate__animated animate__fadeIn"}>
              <h2>{t("contact.title")}</h2>
              <h3>
                {t("contact.description")}
              </h3>
            </div>
          </Col>

          <Col sm={9} className="mt-4">
            <ContactForm />
          </Col>

          <Col sm={9} className="mt-3">
            <Nav>
              <Nav.Link
                className="button-link"
                href={`mailto:mirianalejandra1996@gmail.com?subject=${encodeURIComponent(t("contact.emailSubject"))}`}
              >
                <p className="link-white">mirianalejandra1996@gmail.com</p>
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
